export default __webpack_public_path__ + "static/media/picture_scroll8.62c27efb.jpg";